import React, { createContext, useMemo, useState } from 'react';
import type { ILiferayState, LiferayContextProps } from '../types';

const INITIAL_STATE: ILiferayState = {
  antecedenceTime: {
    national: 4,
    international: 4,
  },
};

export const LiferayContext = createContext<LiferayContextProps>({
  liferayState: INITIAL_STATE,
  updateLiferayState: {} as LiferayContextProps['updateLiferayState'],
});

const LiferayProvider = ({ children }: { children: React.ReactNode }) => {
  const [nationalAntecedence, setNationalAntecedence] = useState<ILiferayState['antecedenceTime']['national']>(
    INITIAL_STATE.antecedenceTime.national,
  );
  const [internationalAntecedence, setInternationalAntecedence] = useState<
    ILiferayState['antecedenceTime']['international']
  >(INITIAL_STATE.antecedenceTime.international);

  const liferayState: ILiferayState = {
    antecedenceTime: {
      international: internationalAntecedence,
      national: nationalAntecedence,
    },
  };

  const updateLiferayState: LiferayContextProps['updateLiferayState'] = {
    antecedenceTime: {
      international: (state: ILiferayState['antecedenceTime']['international']) => setInternationalAntecedence(state),
      national: (state: ILiferayState['antecedenceTime']['national']) => setNationalAntecedence(state),
    },
  };

  const props: LiferayContextProps = useMemo(
    () => ({ liferayState, updateLiferayState }),
    [nationalAntecedence, internationalAntecedence],
  );

  return <LiferayContext.Provider value={props}>{children}</LiferayContext.Provider>;
};

export default LiferayProvider;
